export default __webpack_public_path__ + "static/media/app-bar-account.3e827340.svg";